import _ from 'lodash'
import { baseURL, formatFetchError, fetchHeaders } from '@/api/util'
import { Api, Common, Vehicle } from '@cruz-com/lookup'

export const vehicle = {
  search,
  post,
  getForUpdate,
  sortPhotos,
  deletePhotos,
  deleteVehicle,
  undeleteVehicle,
  getMakeSuggestion,
  getModelSuggestion,
  markAsSold,
}

// search
export async function search(params: object): Promise<Api.Result<Vehicle.Summary>> {
  try {
    const res = await fetch(`${baseURL}/my/vehicles?${new URLSearchParams(params as Record<string, string>)}`, {
      method: 'GET',
      headers: await fetchHeaders(),
      next: { revalidate: 0 },
      cache: 'no-store'
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}

// post
export async function post(formData: FormData): Promise<Api.Result<Vehicle.ForUpdate>> {
  try {
    const res = await fetch(`${baseURL}/my/vehicle`, {
      method: 'POST',
      headers: await fetchHeaders(true),
      body: formData,
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}

// for update
export async function getForUpdate(id: any): Promise<Api.Result<Vehicle.ForUpdate> | any> {
  try {
    if (!id) {
      return Promise.resolve({})
    }
    const res = await fetch(`${baseURL}/my/vehicle/for-update?id=${id}`, {
      method: 'GET',
      headers: await fetchHeaders(),
      next: { revalidate: 0 },
      cache: 'no-store'
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d?.data)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}

// delete 
export async function deleteVehicle(id: string): Promise<Api.Result<Partial<Vehicle.Summary>>> {
  try {
    const res = await fetch(`${baseURL}/vehicle/${id}`, {
      method: 'DELETE',
      headers: await fetchHeaders(),
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}

// undelete 
export async function undeleteVehicle(id: string): Promise<Api.Result<Partial<Vehicle.Summary>>> {
  try {
    const res = await fetch(`${baseURL}/vehicle/${id}/undelete`, {
      method: 'PATCH',
      headers: await fetchHeaders(),
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}

// sold
export async function markAsSold(id: string, price: number): Promise<Api.Result<Partial<Vehicle.Summary>>> {
  try {
    const res = await fetch(`${baseURL}/vehicle/${id}/sold`, {
      method: 'PATCH',
      headers: await fetchHeaders(),
      body: JSON.stringify({ price })
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}

// sort photos
export async function sortPhotos(id: string, photo_list: Common.Photo[]): Promise<Api.Result<Common.Photo[] | any>> {
  try {
    const res = await fetch(`${baseURL}/vehicle/${id}/sort-photos`, {
      method: 'PATCH',
      headers: await fetchHeaders(),
      body: JSON.stringify({ photo_list })
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}

// delete photos
export async function deletePhotos(id: string, photo_list: Common.Photo[]): Promise<Api.Result<Common.Photo[] | any>> {
  try {
    const res = await fetch(`${baseURL}/vehicle/${id}/photos`, {
      method: 'DELETE',
      headers: await fetchHeaders(),
      body: JSON.stringify({ photo_list })
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}

// make suggestion
export async function getMakeSuggestion(make: string): Promise<Api.Result<string[]>> {
  try {
    const res = await fetch(`${baseURL}/vehicle/make-suggestion?make=${make}`, {
      method: 'GET',
      headers: await fetchHeaders()
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}

export async function getModelSuggestion(make: string, model: string): Promise<Api.Result<string[]>> {
  try {
    if (!make || !model) {
      return Promise.resolve({ meta: {}, data: [] })
    }
    const res = await fetch(`${baseURL}/vehicle/model-suggestion?make=${make}&model=${model}`, {
      method: 'GET',
      headers: await fetchHeaders()
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}